<ngx-loading [show]="loading"></ngx-loading>

<h2 mat-dialog-title>Aplica pentru job-ul: <b> {{job.name}}</b> </h2>

<mat-dialog-content style="height: 85%!important;">

</mat-dialog-content>

<mat-dialog-actions>
  <div class="actions">

    <div class="action-buttons">
      <button class="mat-raised-button mat-primary" (click)="apply()" >Aplica</button>
    </div>

  </div>
</mat-dialog-actions>
